<template>
<div>
      <div :class="[preClass ,'container']">
        <base-table :data="stockAnalysis"></base-table>
        <div class="tips-wrap">
          <p style="color:#13C2C2">提示：请定期核对账上库存与实际库存的一致性！</p>
        </div>
        <!-- <div class="tips-wrap">
          <p style="color:#CC0C00">提示：如果末级科目库存出现负数了，显示“库存出现负数，及时核对账上库存与实际库存的一致性“</p>
        </div> -->
        <subjectDetail   ref="detail" :title="title" :label='label' :data = 'subjectData'></subjectDetail>
    </div>
</div>

</template>

<script>
import { mapGetters } from "vuex";
import subjectDetail from '@/components/commons/subject-detail'

export default {
  components:{subjectDetail},
  data() {
    return {
      preClass: "stock-analyse",
      stockAnalysis:[],
      label:'存货分析',
      subjectData :[],
      hasTips:false,
    };
  },
    computed: {
    ...mapGetters(["currClient", "currDate"]),
    title(){
      return  this.currDate.substr(0,7).replace('-','/')+this.label
    }

  },
  mounted() {
    this.getSubjectData()
  },
  methods: {
        getSubjectData() {
      this.subjectData = []
      this.stockAnalysis = [];
      this.hasTips = false
      let params = {
        begin_ym: this.currDate,
        end_ym: this.currDate,
        page: 1,
        rows: 99999999
      };
      this.$axios.post("/account-book/account-balance", params).then(res => {
        console.log('往来款项科目',res)
        if (res.success && res.rows) {
          let resultArr = [];
          let subData = []
          let all = 0
          let allCount = 0
          res.rows.forEach(item => {
                if(Number(item.code)>1400&&Number(item.code)<1412){
                  if(Number(item.end_balance)){
                   all = all+Number(item.end_balance)
                  }
                 if(Number(item.end_count)){
                   allCount = allCount+Number(item.end_count)
                  }
                  
                    if(this.getChildren([item]).length>0){
                    subData =  subData.concat(this.getChildren([item]))
                    } 
                }
          });
        resultArr = [
            {
                  title: '存货账面余额',
                  value: all,
                  align: "around",
                  click: this.handleTableClick,
                  color: "blue",
                  filter: "toThousandFilter"
          },
             {
                  title: '存货账面数量',
                  value: allCount,
                  align: "around",
                  click: this.handleTableClick,
                  color: "blue",
                  filter: "toThousandFilter"
          }
          ]
          if(this.hasTips){
            resultArr.push(
              {
              valueType:'tips',
              tips:'库存出现负数，及时核对账上库存与实际库存的一致性'

            }
            )
          }
          this.subjectData = subData
          this.stockAnalysis = resultArr
 
        }
      }).finally(_=>{
       this.$store.commit('app/SET_LOADING_STATUS', false)
      });
    },
      getChildren(data){
      let arr = []
      data.forEach(item=>{
        if(item.is_leaf===1){
          arr.push({
                  ...item,
                  title: item.name,
                  value: item.end_balance,
                  align: "around",
                  color: "blue",
                  filter: "toThousandFilter"
          })
          if(item.end_balance<0){
            this.hasTips = true
          }

        }else if(item.children) {
        arr =  arr.concat(this.getChildren(item.children)) 
        }
        
      })
      return arr
    },
    handleTableClick(){
      this.$refs.detail.show = true
    }
  }
};
</script>

<style lang='less'>
.stock-analyse{
  &-title{

  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/financial-report/stock-analyse/index.vue